import React from 'react'

import './InputWrapper.css'

export function InputWrapper({ label, note , fluid , required , error,  children }) {
	return (
		<div className={`field-group group-wrapper${ fluid ? ' fluid' : ''}`}>
			{label && <label>{label} {required ? '*' : ''}</label>}
            { error && <div className='field--error'>{error}</div>}
            <div className={`input-wrapper-content`}>{ children }</div>
            { note && <div className='field--note'>{note}</div>}
		</div>
	)
}